/**
 * Connection feedback — US 10.02, pure DOM.
 * Tier 2: non-blocking "Reconnecting…" pill. Movement continues.
 * Tier 3: the full blocking overlay. All input disabled (the world side
 * freezes intents on the same bus event).
 */
import { worldBus } from '@shared/bus.js';

export function initConnectionIndicator(root: HTMLElement): void {
  const pill = document.createElement('div');
  pill.className = 'wca-conn-pill hidden';
  pill.textContent = 'Reconnecting…';

  const overlay = document.createElement('div');
  overlay.className = 'wca-conn-overlay hidden';
  const box = document.createElement('div');
  box.className = 'wca-conn-box';
  const title = document.createElement('strong');
  title.textContent = 'Connection Lost — Game Paused';
  const detail = document.createElement('p');
  detail.textContent =
    'Reconnecting automatically. Your progress is safe: nothing is lost, and no action can apply twice.';
  box.append(title, detail);
  overlay.appendChild(box);

  root.append(pill, overlay);

  worldBus.on('connection-tier', ({ tier }) => {
    pill.classList.toggle('hidden', tier !== 2);
    overlay.classList.toggle('hidden', tier !== 3);
  });
}
